import React, { Component } from 'react';

import { Button, Checkbox, FormControlLabel /* , MenuItem, Radio, Typography, Icon, IconButton */, Input } from 'material-ui';
import {
    DialogActions
} from 'material-ui/Dialog';
import { withStyles } from 'material-ui/styles';
import Loader from "other-components/loader/loader";
import ReactTable from "react-table";

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import axios from 'axios/index';
import { confirmAlert } from 'react-confirm-alert';

const styles = theme => ({
    layoutRoot: {},
    input: {
        width: "100%",
        textAlign: "right",
        fontSize: '1.8rem'
    }
});

const tdStyle = { 'width': '14.285714%' };
const tdStyle2 = { 'width': '28.571428%' };


class ItemAdder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,

            customerType: 'All',
            currentRecord: {
                itemCode: '',
                itemName: '',
                quantity: '0',
                unitPrice: '0.00',
                discount: '0.00',
                isDiscountPercentage: false,
                //discount : '10',
                netPrice: '0.00'
            },
            allItemList: [],
            itemCodeList: [],
            itemNameList: [],

            records: [],

            quantity: 'abc',
            selectedTaxOption: 'tax_invoice',
            transportAndExtra: '0',
            discount: '0',
            isDiscountPercentage: false,

            canAdd: false
        };

        this.handleEditClick = this.handleEditClick.bind(this);
        this.focusQuantity = this.focusQuantity.bind(this);
        this.blurQuantity = this.blurQuantity.bind(this);
        this.focusDiscount = this.focusDiscount.bind(this);
        this.blurDiscount = this.blurDiscount.bind(this);


    }

    componentWillMount() {
        this.getItemList();
    }

    getItemList() {
        console.log('getItemList');
        this.setState({ loading: true });
        const request = axios.get(window.inventoryServer + '/inventory/get/itemViewBasic');
        request.then((response) => {
            console.log('response');
            if (!response.data.error) {
                console.log('item data recieved', response.data);
                let allItemList = [];
                let itemCodeList = [];
                let itemNameList = [];

                for (let i = 0; i < response.data.result.length; i++) {
                    allItemList.push({
                        itemCode: '_ITM' + response.data.result[i].ID_ITEM, itemName: response.data.result[i].GENERAL_NAME,
                        retailPrice: response.data.result[i].RETAIL_PRICE, wholesalePrice: response.data.result[i].WHOLESALE_PRICE,
                        maximumDiscount: response.data.result[i].MAXIMUM_DISCOUNT, minimumSellingPrice: response.data.result[i].SELLING_PRICE
                    });
                    itemCodeList.push({ value: '_ITM' + response.data.result[i].ID_ITEM, label: response.data.result[i].ID_ITEM });
                    itemNameList.push({ value: '_ITM' + response.data.result[i].ID_ITEM, label: response.data.result[i].GENERAL_NAME + ' [ Rs.' + response.data.result[i].RETAIL_PRICE + ' ]' });
                }

                const request2 = axios.get(window.inventoryServer + '/inventory/get/serviceViewBasic');
                request2.then((response2) => {
                    console.log('service data recieved', response2.data);

                    for (let i = 0; i < response2.data.result.length; i++) {
                        allItemList.push({
                            itemCode: '_SRVICE' + response2.data.result[i].ID_ITEM, itemName: response2.data.result[i].GENERAL_NAME,
                            retailPrice: response2.data.result[i].RETAIL_PRICE, wholesalePrice: response2.data.result[i].WHOLESALE_PRICE,
                            maximumDiscount: response2.data.result[i].MAXIMUM_DISCOUNT, minimumSellingPrice: response2.data.result[i].SELLING_PRICE
                        });
                        itemCodeList.push({ value: '_SRVICE' + response2.data.result[i].ID_ITEM, label: response2.data.result[i].ID_ITEM });
                        itemNameList.push({ value: '_SRVICE' + response2.data.result[i].ID_ITEM, label: response2.data.result[i].GENERAL_NAME + ' [ Rs.' + response2.data.result[i].RETAIL_PRICE + ' ]' });
                    }

                    this.setState({
                        allItemList: allItemList,
                        itemCodeList: itemCodeList,
                        itemNameList: itemNameList
                    });

                    this.setState({ loading: false });
                })
                    .catch((error) => {
                        console.log('error', response.data.error);
                        this.setState({ loading: false });
                    });

            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    handleCheckBoxChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleEditClick = (row) => {
        console.log('edit clicked', row);
        var records = this.state.records;
        var editRecord = {
            itemCode: row.itemCode,
            itemName: row.itemName,
            isService: row.isService,
            quantity: row.quantity,
            unitPrice: row.unitPrice,
            discount: row.discount,
            isDiscountPercentage: row.isDiscountPercentage,
            netPrice: row.netPrice
        };

        for (let i = 0; i < records.length; i++) {
            console.log('loop');
            console.log(JSON.stringify(records[i]));
            console.log(JSON.stringify(editRecord));
            if (JSON.stringify(records[i]) === JSON.stringify(editRecord)) {
                console.log('matched', i);

                records.splice(i, 1);
                this.setState({ records: records },
                    () => {
                        this.updateBillingValues();
                    });

                let unitPrice = row.unitPrice;
                if (this.state.selectedTaxOption == 'non_tax_invoice') {
                    unitPrice = parseFloat(unitPrice) * 100 / 115;
                    unitPrice = unitPrice * 100 / 102;
                }

                let netPrice = row.netPrice;
                if (this.state.selectedTaxOption == 'non_tax_invoice') {
                    netPrice = parseFloat(netPrice) * 100 / 115;
                    netPrice = netPrice * 100 / 102;
                }



                this.setState({
                    currentRecord: {
                        itemCode: { value: row.itemCode, label: row.itemCode },
                        itemName: { value: row.itemCode, label: row.itemName },
                        quantity: row.quantity,
                        unitPrice: unitPrice,
                        discount: row.discount,
                        isDiscountPercentage: row.isDiscountPercentage,
                        //discount : '10',
                        netPrice: netPrice
                    }
                });
                break;
            }
        }

    };

    handleRemoveClick = (row) => {
        console.log('edit clicked', row);
        var records = this.state.records;
        var editRecord = {
            itemCode: row.itemCode,
            itemName: row.itemName,
            isService: row.isService,
            quantity: row.quantity,
            unitPrice: row.unitPrice,
            discount: row.discount,
            isDiscountPercentage: row.isDiscountPercentage,
            netPrice: row.netPrice
        };

        for (let i = 0; i < records.length; i++) {
            console.log('loop');
            console.log(JSON.stringify(records[i]));
            console.log(JSON.stringify(editRecord));
            if (JSON.stringify(records[i]) === JSON.stringify(editRecord)) {
                console.log('matched', i);

                records.splice(i, 1);
                this.setState({ records: records }, () => {
                    this.updateBillingValues();
                });
                break;
            }
        }
    };


    handleItemCodeChange = (selectedOption) => {
        if (selectedOption) {
            for (let i = 0; i < this.state.allItemList.length; i++) {
                if (this.state.allItemList[i].itemCode == selectedOption.value) {
                    //console.log('found');

                    var isService = null;
                    var itemName = ''
                    if (this.state.allItemList[i].itemCode.substring(0, 4) == '_ITM') {
                        isService = 0;
                    }
                    else if (this.state.allItemList[i].itemCode.substring(0, 7) == '_SRVICE') {
                        isService = 1;
                    }

                    this.setState(prevState => ({
                        currentRecord: {
                            ...prevState.currentRecord,
                            itemCode: selectedOption,
                            itemName: { value: selectedOption.value, label: this.state.allItemList[i].itemName },
                            isService: isService,
                            unitPrice: this.state.customerType == 'Retail' ? this.state.allItemList[i].retailPrice : this.state.allItemList[i].wholesalePrice,
                            quantity: '1',
                            netPrice: this.state.customerType == 'Retail' ? this.state.allItemList[i].retailPrice : this.state.allItemList[i].wholesalePrice,
                            maximumDiscount: this.state.allItemList[i].maximumDiscount,
                            minimumSellingPrice: this.state.allItemList[i].minimumSellingPrice
                        }
                    }));


                    break;
                }
            }
        }
        else {
            this.setState(prevState => ({
                currentRecord: {
                    ...prevState.currentRecord,
                    itemCode: '',
                    itemName: '',
                    quantity: '0',
                    netPrice: '0.00',
                    unitPrice: '0.00'
                }
            }));
        }
    }

    handleItemNameChange = (selectedOption) => {
        if (selectedOption) {
            console.log('handleItemNameChange selectedOption', selectedOption)
            for (let i = 0; i < this.state.allItemList.length; i++) {
                if (this.state.allItemList[i].itemCode == selectedOption.value) {

                    var isService = null;
                    var itemName = ''
                    if (this.state.allItemList[i].itemCode.substring(0, 4) == '_ITM') {
                        itemName = this.state.allItemList[i].itemCode.substring(4, this.state.allItemList[i].itemCode.length);
                        isService = 0;
                    }
                    else if (this.state.allItemList[i].itemCode.substring(0, 7) == '_SRVICE') {
                        itemName = this.state.allItemList[i].itemCode.substring(7, this.state.allItemList[i].itemCode.length);
                        isService = 1;
                    }

                    this.setState(prevState => ({
                        currentRecord: {
                            ...prevState.currentRecord,
                            itemName: selectedOption,
                            itemCode: { value: selectedOption.value, label: itemName },
                            isService: isService,
                            unitPrice: this.state.customerType == 'Retail' ? this.state.allItemList[i].retailPrice : this.state.allItemList[i].wholesalePrice,
                            quantity: '1',
                            netPrice: this.state.customerType == 'Retail' ? this.state.allItemList[i].retailPrice : this.state.allItemList[i].wholesalePrice,
                            maximumDiscount: this.state.allItemList[i].maximumDiscount,
                            minimumSellingPrice: this.state.allItemList[i].minimumSellingPrice,
                        }
                    }),
                        () => {
                            console.log('current record changed: ', this.state.currentRecord);
                        });
                    break;
                }
            }
        }
        else {
            this.setState(prevState => ({
                currentRecord: {
                    ...prevState.currentRecord,
                    itemCode: '',
                    itemName: '',
                    quantity: '0',
                    netPrice: '0.00',
                    unitPrice: '0.00'
                }
            }));
        }
    }

    handleOtherTextChange = prop => event => {
        var value = event.target.value;
        if (prop == 'transportAndExtra') {
            value = !isNaN(value) ? value : this.state.transportAndExtra
            //value = this.getNumber(value, this.state.transportAndExtra);
        }
        else if (prop = 'discount') {
            value = !isNaN(value) ? value : this.state.discount
            //value = this.getNumber(value, this.state.transportAndExtra);
        }
        this.setState({ [prop]: value }, () => {
            this.updateBillingValues();
        });
    }

    handleCurrentRecordTextChange = prop => event => {

        var value = event.target.value;

        if (prop == 'quantity') {
            //var netPrice = parseFloat(this.state.currentRecord.unitPrice).toFixed(2) * event.target.value;
            console.log('netPrice', parseFloat(this.state.currentRecord.unitPrice).toFixed(2));

            //var discount = this.state.currentRecord.discount?this.state.currentRecord.discount:0;

            console.log('current record discount', this.state.currentRecord.discount);

            console.log('value from input', value);

            this.calculateAndSetNetPrice(this.getNumber(value, String(this.state.currentRecord.quantity).slice()),
                this.state.currentRecord.unitPrice,
                this.getNumberDefyNullZero(this.state.currentRecord.discount),
                this.state.currentRecord.isDiscountPercentage);
            value = !isNaN(value) ? value : this.state.currentRecord.quantity;
        }
        else if (prop == 'discount') {
            //value = parseFloat(value)>parseFloat(this.state.currentRecord.unitPrice)? this.state.currentRecord.unitPrice

            this.calculateAndSetNetPrice(this.getNumberDefyNullZero(this.state.currentRecord.quantity),
                this.state.currentRecord.unitPrice,
                this.getNumber(value, this.state.currentRecord.discount),
                this.state.currentRecord.isDiscountPercentage);
            value = !isNaN(value) ? value : this.state.currentRecord.discount;
        }

        this.setState(prevState => ({
            currentRecord: {
                ...prevState.currentRecord,
                [prop]: value
            }
        }));
    };

    getNumber(value, prevValue) {
        //console.log('getNumber params', value, prevValue);
        if (!value.toString().replace(/\s/g, '').length) {
            //console.log('getNumber', 0)
            return 0;
        }
        if (!isNaN(value)) {
            //console.log('getNumber', value)
            return value;
        }
        else if (prevValue) {
            //console.log('getNumber', prevValue  )
            return prevValue;
        } else {
            //console.log('getNumber', 0  )
            return 0;
        }
    }

    getNumberDefyNullZero(value) {
        if (value && !isNaN(value)) {
            //console.log('getNumberDefyNullZero', value)
            return value;
        } else {
            //console.log('getNumberDefyNullZero', 0  )
            return 0;
        }
    }



    calculateAndSetNetPrice(quantity, unitPrice, discount, isDiscountPercentage) {
        console.log('calNetPrice', quantity, unitPrice, discount, isDiscountPercentage);
        var netPrice = parseFloat(unitPrice).toFixed(2) * quantity;
        var priceWithDiscount = 0.00;
        if (isDiscountPercentage) {
            priceWithDiscount = netPrice * (100 - discount) / 100;
        } else {
            priceWithDiscount = netPrice.toFixed(2) - parseFloat(discount).toFixed(2);
        }
        console.log('netPrice', netPrice);
        this.setState(prevState => ({
            currentRecord: {
                ...prevState.currentRecord,
                netPrice: priceWithDiscount.toFixed(2)
            }
        }));
    }

    handleCurrentRecordCheckBoxChange = name => event => {

        var value = event.target.checked;
        this.setState(prevState => ({
            currentRecord: {
                ...prevState.currentRecord,
                [name]: value
            }
        }));

        if (name == 'isDiscountPercentage') {
            this.calculateAndSetNetPrice(this.getNumberDefyNullZero(this.state.currentRecord.quantity),
                this.getNumberDefyNullZero(this.state.currentRecord.unitPrice)
                , this.getNumberDefyNullZero(this.state.currentRecord.discount)
                , value);
        }

        //this.setState({ [name]: event.target.checked });
    };

    handleAddButtonClick = () => {
        if (this.state.customerType == 'Retail' || this.state.customerType == 'Wholesale') {
            var currentRecord = this.state.currentRecord;
            var discountPerItem = currentRecord.isDiscountPercentage ?
                parseFloat(currentRecord.unitPrice) * parseFloat(currentRecord.discount) / 100
                : currentRecord.discount;

            if (currentRecord.minimumSellingPrice) {
                if (parseFloat(parseFloat(currentRecord.netPrice).toFixed(2)) < parseFloat(parseFloat(currentRecord.minimumSellingPrice).toFixed(2))) {
                    console.log('currentRecord.netPrice', parseFloat(currentRecord.netPrice).toFixed(2), 'currentRecord.minimumSellingPrice', (currentRecord.minimumSellingPrice).toFixed(2));
                    confirmAlert({
                        title: 'Item price', message: 'Net price of item is below minimum selling price',
                        buttons: [{ label: 'Ok' }]
                    })
                    return;
                }
            }
            if (currentRecord.maximumDiscount && parseFloat(parseFloat(discountPerItem).toFixed(2)) > currentRecord.maximumDiscount) {
                confirmAlert({
                    title: 'Item discount', message: 'Item discount is above maximun discount',
                    buttons: [{ label: 'Ok' }]
                })
                return;
            }


            let extraUnitPrice = 0.00;
            if (this.state.selectedTaxOption == 'non_tax_invoice') {
                extraUnitPrice = parseFloat(currentRecord.unitPrice) * 102 / 100;
                extraUnitPrice = parseFloat(extraUnitPrice) * 115 / 100;
                //extraUnitPrice = extraUnitPrice * 102/100;
                extraUnitPrice = parseFloat(extraUnitPrice) - parseFloat(currentRecord.unitPrice);
            }

            let unitPrice = (parseFloat(currentRecord.unitPrice) + parseFloat(extraUnitPrice)).toFixed(2);
            let netPrice = (parseFloat(currentRecord.netPrice) + parseFloat(extraUnitPrice) * parseFloat(currentRecord.quantity)).toFixed(2);
            // extraUnitPrice = parseFloat(unitPrice).toFixed(2)

            let prevRecords = [...this.state.records];
            let addNewToRecords = true;

            for (let i = 0; i < prevRecords.length; i++) {
                if (currentRecord.itemCode.label == prevRecords[i].itemCode && currentRecord.isService == prevRecords[i].isService) {
                    let discount = 0.00;
                    let isDiscountPercentage = false;
                    if (prevRecords[i].isDiscountPercentage == currentRecord.isDiscountPercentage
                        && prevRecords[i].discount == currentRecord.discount) {
                        prevRecords[i].quantity = parseFloat(currentRecord.quantity) + parseFloat(prevRecords[i].quantity);
                        prevRecords[i].netPrice = parseFloat(currentRecord.netPrice) + parseFloat(prevRecords[i].netPrice);
                        if (!currentRecord.isDiscountPercentage) {
                            prevRecords[i].discount = parseFloat(currentRecord.discount) + parseFloat(prevRecords[i].discount);
                        }
                        addNewToRecords = false;
                        break;
                    }
                }
            }

            if (!addNewToRecords) {
                this.setState(prevState => ({
                    records: prevRecords
                }),
                    () => {
                        console.log('records added ', this.state.records);
                        this.updateBillingValues();
                        this.handleResetClick();
                    });
            } else {
                var newelement = {
                    itemCode: currentRecord.itemCode.label,
                    itemName: currentRecord.itemName.label,
                    isService: currentRecord.isService,
                    quantity: currentRecord.quantity,
                    unitPrice: unitPrice,
                    discount: currentRecord.discount,
                    isDiscountPercentage: currentRecord.isDiscountPercentage,
                    netPrice: netPrice
                };
                this.setState(prevState => ({
                    records: [...prevState.records, newelement]
                }),
                    () => {
                        console.log('records added ', this.state.records);
                        this.updateBillingValues();
                        this.handleResetClick();
                    });
            }





            //console.log('sending items to parent', this.state.records);

        }
        else {
            console.log('Please select customer type');
            //this.props.alertFunction('Please select customer type','Error');
        }

    };

    updateBillingValues() {
        this.props.updateValues({
            records: this.state.records,
            sumValues: {
                netAmount: this.getNetAmount().toFixed(2),
                discount: this.state.discount,
                isDiscountPercentage: this.state.isDiscountPercentage,
                // NBT: this.getNBT().toFixed(2),
                // VAT: this.getVAT().toFixed(2),
                grossAmount: this.totalGrossAmount().toFixed(2),
                transportAndExtra: this.state.transportAndExtra
            }
        });
    }

    handleResetClick = () => {
        this.setState(prevState => ({
            currentRecord: {
                ...prevState.currentRecord,
                itemCode: '',
                itemName: '',
                quantity: '0',
                unitPrice: '0.00',
                discount: '0.00',
                isDiscountPercentage: false,
                netPrice: '0.00'
            }
        }));
    };

    totalGrossAmount() {
        var total = 0.00;
        for (let i = 0; i < this.state.records.length; i++) {
            total = total + parseFloat(this.state.records[i].netPrice);
        }
        total = total ;
        //console.log(total);
        return total;
    }

    getAmountAfterDiscount() {
        var discount = parseFloat(this.getNumber(this.state.discount, 0));
        if (this.state.isDiscountPercentage) {
            var amount = this.totalGrossAmount().toFixed(2) * (100 - discount) / 100;
        }
        else {
            var amount = this.totalGrossAmount().toFixed(2) - discount.toFixed(2);
        }
        return amount;
    }

    // getNBT() {
    //     return this.getAmountAfterDiscount();

    //     //return this.totalGrossAmount().toFixed(2)*3/100;
    // }

    // getVAT() {
    //     return this.getAmountAfterDiscount().toFixed(2) * 8 / 100;
    //     // return this.getAmountAfterDiscount().toFixed(2)*15/100;
    // }

    getNetAmount() {

        var amountAfterDiscount = this.getAmountAfterDiscount().toFixed(2);
        console.log('amountAfterDiscount', amountAfterDiscount);
        var totalTax = parseFloat(0.00);

        if (this.state.selectedTaxOption == 'tax_invoice') {
            // totalTax = parseFloat(totalTax) + parseFloat(this.getNBT().toFixed(2)) + parseFloat(this.getVAT().toFixed(2));
            // totalTax = parseFloat(totalTax) + parseFloat(this.getVAT().toFixed(2));
            totalTax = parseFloat(totalTax);
        } else if (this.state.selectedTaxOption == 'suspended_tax_invoice') {
            // totalTax = parseFloat(totalTax) + parseFloat(this.getNBT().toFixed(2))
            totalTax = parseFloat(totalTax)
        }


        var netAmount = parseFloat(amountAfterDiscount) + parseFloat(totalTax)+ parseFloat(this.getNumber(this.state.transportAndExtra, 0));
        console.log('Tax', totalTax);
        console.log('Net amount', netAmount);
        return parseFloat(netAmount);
    }

    focusQuantity(event) {
        event.stopPropagation();
        if (event.target.value == 0) {
            this.setState(prevState => ({
                currentRecord: {
                    ...prevState.currentRecord,
                    quantity: '',
                }
            }));
        }
    }

    blurQuantity(event) {
        event.stopPropagation();
        if (event.target.value == 0 || event.target.value == '') {
            this.setState(prevState => ({
                currentRecord: {
                    ...prevState.currentRecord,
                    quantity: '1',
                }
            }));
        }
    }

    focusDiscount(event) {
        event.stopPropagation();
        if (event.target.value == 0) {
            this.setState(prevState => ({
                currentRecord: {
                    ...prevState.currentRecord,
                    discount: '',
                }
            }));
        }
    }

    blurDiscount(event) {
        event.stopPropagation();
        if (event.target.value == 0 || event.target.value == '') {
            this.setState(prevState => ({
                currentRecord: {
                    ...prevState.currentRecord,
                    discount: '0.00',
                }
            }));
        }
    }



    render() {
        const { classes } = this.props;

        var divTaxRowStyle = (value, stateC) => {
            /* if (stateC == value) {
                console.log('divStyle macthed', value, stateC);
                return { display: 'none', margin: 0 };
            }
            else {
                console.log('divStyle not macthed', value, stateC);
                return { display: '', margin: 0 };
            } */
            if (value.includes(stateC)) {
                console.log('divStyle macthed', value, stateC);
                return { display: 'none', margin: 0 };
            }
            else {
                console.log('divStyle not macthed', value, stateC);
                return { display: '', margin: 0 };
            }
        };

        var bottomSVATStyle = () => {
            if (this.state.selectedTaxOption == 'suspended_tax_invoice') {
                return { display: '', margin: 0 };
            }
            else {
                return { display: 'none', margin: 0 };
            }
        };


        if (this.state.loading) {
            return (
                <Loader />
            );
        }
        else {
            return (
                <div>
                    {/* <div>{this.state.customerType}</div>
                <div>Tax Option: {this.state.selectedTaxOption}</div>


                <div>
                    {this.state.records.length}
                </div>  */}

                    <div className="mb-16 ">
                        <table>
                            <thead>
                                <td className="min-w-128 text-center font-800">Item Code</td>
                                <td className="min-w-256 text-center font-800">Item / Service Name</td>
                                <td className="min-w-128 text-center font-800">Quantity</td>
                                <td className="min-w-128 text-center font-800">Unit Price</td>
                                <td className="min-w-128 text-center font-800">Discount</td>
                                <td className="min-w-64 text-center font-800">Net Price</td>
                                <td className="min-w-256 text-center font-800"></td>
                            </thead>
                            <tbody >
                                <tr>
                                    <td>
                                        <Select
                                            className="min-w-128 inline-block"
                                            name="form-field-name"
                                            placeholder="Code"
                                            value={this.state.currentRecord.itemCode}
                                            onChange={this.handleItemCodeChange}
                                            options={this.state.itemCodeList}
                                        />
                                    </td>
                                    <td>
                                        <Select
                                            className="min-w-256 inline-block"
                                            name="form-field-name"
                                            placeholder="Item Name"
                                            value={this.state.currentRecord.itemName}
                                            onChange={this.handleItemNameChange}
                                            options={this.state.itemNameList}
                                        />
                                    </td>
                                    <td className="payment-table-margin">
                                        <Input
                                            label={null}
                                            className="max-w-128 inline-block"
                                            id="input-quantity"
                                            value={this.state.currentRecord.quantity}
                                            onFocus={this.focusQuantity}
                                            onBlur={this.blurQuantity}
                                            onChange={this.handleCurrentRecordTextChange('quantity')}
                                        />
                                    </td>
                                    <td className="payment-table-margin">
                                        <Input
                                            label={null}
                                            className="max-w-128 inline-block "
                                            id="input-unitprice"
                                            value={this.state.currentRecord.unitPrice}
                                        />
                                    </td>
                                    <td className="payment-table-margin">
                                        <Input
                                            label={null}
                                            className="max-w-64 inline-block "
                                            id="input-discount"
                                            onFocus={this.focusDiscount}
                                            onBlur={this.blurDiscount}
                                            value={this.state.currentRecord.discount}
                                            onChange={this.handleCurrentRecordTextChange('discount')}
                                        />
                                        <FormControlLabel
                                            className=" "
                                            control={
                                                <Checkbox
                                                    checked={this.state.currentRecord.isDiscountPercentage}
                                                    //checked={(this.state.currentRecord.discount.slice(-1)=='%')?true:false}
                                                    onChange={this.handleCurrentRecordCheckBoxChange('isDiscountPercentage')}
                                                    color="primary"
                                                />
                                            }
                                            label="%"
                                        />

                                    </td>
                                    <td>
                                        <Input
                                            label={null}
                                            className="max-w-128 inline-block "
                                            id="input-netprice"
                                            value={this.state.currentRecord.netPrice}
                                        //onChange={this.handleCurrentRecordTextChange('netPrice')}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <DialogActions className=" justify-right pl-16  ">
                            <div className=" mx-8 inline-block" style={{ position: 'relative', bottom: window.env === "IMC" ? "0" : '53px', right: '58px' }}>
                                <Button
                                    //type="submit"
                                    variant="raised"
                                    color="secondary"
                                    className={classes.button}
                                    aria-label="Add"
                                    disabled={this.state.customerType == 'All' || this.getNumber(this.state.currentRecord.quantity, 0) == 0}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.handleAddButtonClick();
                                    }}
                                >
                                    Add
                                </Button>
                            </div>

                            <div className="mx-8 inline-block" style={{ position: 'relative', bottom: window.env === "IMC" ? "0" : '53px', right: '39px' }}>
                                <Button
                                    //type="submit"
                                    variant="raised"
                                    color="primary"
                                    className={classes.button}
                                    aria-label="Reset"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.handleResetClick()
                                    }}
                                >
                                    Reset
                                </Button>
                            </div>
                        </DialogActions>
                    </div>


                    <ReactTable
                        data={this.state.records}
                        columns={[

                            {
                                Header: "Item Code",
                                accessor: "itemCode",
                                width: 150
                            },
                            {
                                Header: "Item Name",
                                accessor: "itemName",
                                width: 150
                            },
                            {
                                Header: "Quantity",
                                accessor: "quantity",
                                width: 150
                            },
                            {
                                Header: "Unit Price",
                                width: 150,
                                //accessor: "unitPrice"
                                Cell: row => (
                                    <div align="left" className="w-full">
                                        {row.original.unitPrice}
                                    </div>
                                )
                            },
                            {
                                Header: "Discount",
                                width: 150,
                                Cell: row => (
                                    <div align="left" className="w-full">
                                        {row.original.isDiscountPercentage ? row.original.discount + '%' : row.original.discount}
                                    </div>
                                )
                            },
                            {
                                Header: "Net Price",
                                width: 150,
                                //accessor: "netPrice"
                                Cell: row => (
                                    <div align="left" className="w-full">
                                        {row.original.netPrice}
                                    </div>
                                )
                            },
                            {
                                Header: "Action",
                                width: 200,
                                Cell: row => (
                                    <DialogActions className=" justify-right ">
                                        <Button
                                            //type="submit"
                                            variant="raised"
                                            color="secondary"
                                            className="{classes.button} "
                                            aria-label="Edit"
                                            onClick={(ev) => {
                                                ev.stopPropagation();

                                                this.handleEditClick(row.original);
                                            }}
                                        >
                                            Edit
                                        </Button>


                                        <Button
                                            variant="raised"
                                            color="primary"
                                            className="{classes.button} table-btn-margin"
                                            aria-label="Remove"
                                            onClick={(ev) => {
                                                ev.stopPropagation();

                                                this.handleRemoveClick(row.original);
                                            }}
                                        >
                                            Remove
                                        </Button>

                                    </DialogActions>
                                )
                            }
                            /* {
                                Header: "Status",
                                Cell: row => <span>{row.original.unit_catagory_isActive ? "Active" : "Inactive"}</span>
                            }, */

                            /* {
                                Header: "",
                                width: 128,
                                Cell: row => (
                                     )
                            } */
                        ]}
                        pageSize={this.state.records.length > 3 ? this.state.records.length : 3}
                        //defaultPageSize={10}
                        className="-striped -highlight"
                    />

                    <div>
                        <table className="w-full border-collapse" style={{ 'border-collapse': 'collapse' }}>
                            <tbody>
                                <tr /* className="bg-green-lightest" */>
                                    <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                                    <td align="right" className="font-800 text-18" style={tdStyle}>Gross Amount</td>
                                    <td align="right" className="text-18" style={tdStyle}>{this.totalGrossAmount().toFixed(2)}</td><td style={tdStyle}></td>
                                </tr>

                                <tr className="">
                                    <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                                    <td align="right" className="font-800 text-18 " style={tdStyle}>
                                        Discount
                                        <Checkbox
                                            checked={this.state.isDiscountPercentage}
                                            onChange={this.handleCheckBoxChange('isDiscountPercentage')}
                                            color="primary"
                                        />
                                        %
                                    </td>
                                    <td align="right" className="text-18 " style={tdStyle}>
                                        <Input
                                            label={null}
                                            className="inline-block"
                                            classes={{
                                                input: classes.input
                                            }}
                                            id="input-quantity"
                                            value={this.state.discount}
                                            onChange={this.handleOtherTextChange('discount')}
                                        />
                                    </td>
                                    <td style={tdStyle}></td>
                                </tr>
                                {window.env === "IMC" ?
                                    <tr /* className=" bg-green-lightest" */>
                                        <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={{ width: '20%' }}></td>
                                        <td align="right" className="font-800 text-18" style={{ "width": "22%" }}>Transport and Extra</td>
                                        <td align="right" className="text-18" style={tdStyle}>
                                            <Input
                                                label={null}
                                                className="inline-block"
                                                classes={{
                                                    input: classes.input
                                                }}
                                                //style = {{width:'100px',textAlign: 'center'}}
                                                id="input-quantity"
                                                value={this.state.transportAndExtra}
                                                //hintStyle={{ width: '100px', textAlign: 'center' }}
                                                onChange={this.handleOtherTextChange('transportAndExtra')}
                                            />
                                        </td>
                                        <td style={tdStyle}></td>
                                    </tr> : ""
                                }
                                {/* <tr style={divTaxRowStyle(['non_tax_invoice'], this.state.selectedTaxOption)}>
                                    <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                                    <td align="right" className="font-800 text-18" style={tdStyle}>NBT</td>
                                    <td align="right" className="text-18" style={tdStyle}>{this.getNBT().toFixed(2)}</td><td style={tdStyle}></td>
                                </tr> */}

                                <tr /* className="bg-green-lightest" */ style={divTaxRowStyle(['non_tax_invoice', 'suspended_tax_invoice'], this.state.selectedTaxOption)}>
                                    <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                                    {/* <td align="right" className="font-800 text-18" style={tdStyle}>VAT</td> */}
                                    {/* <td align="right" className="text-18" style={tdStyle}>{this.getVAT().toFixed(2)}</td><td style={tdStyle}></td> */}
                                </tr>



                                <tr className="">
                                    <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                                    <td align="right" className="font-800 text-18 " style={tdStyle}>Net Amount</td>
                                    <td align="right" className="text-18 " style={tdStyle}>{this.getNetAmount().toFixed(2)}</td><td style={tdStyle}></td>
                                </tr>


                                <tr /* className="bg-green-lightest" */ style={bottomSVATStyle()}>
                                    {/* <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                                    <td align="right" className="font-800 text-18" style={tdStyle}>SVAT</td>
                                    <td align="right" className="text-18" style={tdStyle}>{this.getVAT().toFixed(2)}</td><td style={tdStyle}></td> */}
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log('component will recieve props', nextProps);
        if (nextProps.customerType != this.state.customerType) {
            console.log('new customerType recieved', nextProps.customerType);
            this.setState(
                {
                    customerType: nextProps.customerType
                }
            );
            this.handleResetClick();

        }
        if (nextProps.selectedTaxOption != this.state.selectedTaxOption) {
            console.log('new selectedTaxOption recieved', nextProps.selectedTaxOption);
            this.setState(
                {
                    selectedTaxOption: nextProps.selectedTaxOption,
                    records: [],
                    currentRecord: {
                        itemCode: '',
                        itemName: '',
                        quantity: '0',
                        unitPrice: '0.00',
                        discount: '0.00',
                        isDiscountPercentage: false,
                        //discount : '10',
                        netPrice: '0.00'
                    }
                }
                , () => {
                    this.updateBillingValues();
                });
        }
        if (nextProps.records && JSON.stringify(this.state.records) != JSON.stringify(nextProps.records)
            && nextProps.selectedTaxOption == this.state.selectedTaxOption
        ) {
            console.log('new records recieved', nextProps.records);
            this.setState(
                {
                    records: nextProps.records,
                    //customerType: nextProps.customerType,
                    //alertFunction: nextProps.alertFunction
                }, () => {
                    this.updateBillingValues();
                }
            );
            //this.props.updateValues(nextProps.records);
        }


    }

}


export default withStyles(styles, { withTheme: true })(ItemAdder);



// WEBPACK FOOTER //
// ./src/main/content/sales/billing/itemAdder.js